/**
 * https://github.com/kelektiv/node-uuid
 * Generated for usage in browser with http://wzrd.in/
 *
 * The MIT License (MIT)
 * Copyright (c) 2010-2016 Robert Kieffer and other contributors
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

let rng = (function () {
    // Unique ID creation requires a high quality random # generator.  In the
    // browser this is a little complicated due to unknown quality of Math.random()
    // and inconsistent support for the `crypto` API.  We do the best we can via
    // feature-detection
    var rngFcn;
    // @ts-ignore
    var crypto = window.crypto || window["msCrypto"]; // for IE 11
    if (crypto && crypto.getRandomValues) {
        // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
        var rnds8 = new Uint8Array(16);
        rngFcn = function whatwgRNG() {
            crypto.getRandomValues(rnds8);
            return rnds8;
        };
    }

    if (!rngFcn) {
        // Math.random()-based (RNG)
        //
        // If all else fails, use Math.random().  It's fast, but is of unspecified
        // quality.
        let rnds = new Array(16);
        rngFcn = function () {
            for (let i = 0, r = 0; i < 16; i++) {
                if ((i & 0x03) === 0) {
                    r = Math.random() * 0x100000000;
                }
                rnds[i] = (r >>> ((i & 0x03) << 3)) & 0xff;
            }

            return rnds;
        };
    }

    return rngFcn;
})();

let bytesToUuid = (function () {
    let byteToHex: string[] = [];
    for (let i = 0; i < 256; ++i) {
        byteToHex[i] = (i + 0x100).toString(16).substring(1);
    }

    return function (buf: number[], offset?: number) {
        let i = offset || 0;
        let bth = byteToHex;
        return (
            bth[buf[i++]] +
            bth[buf[i++]] +
            bth[buf[i++]] +
            bth[buf[i++]] +
            "-" +
            bth[buf[i++]] +
            bth[buf[i++]] +
            "-" +
            bth[buf[i++]] +
            bth[buf[i++]] +
            "-" +
            bth[buf[i++]] +
            bth[buf[i++]] +
            "-" +
            bth[buf[i++]] +
            bth[buf[i++]] +
            bth[buf[i++]] +
            bth[buf[i++]] +
            bth[buf[i++]] +
            bth[buf[i++]]
        );
    };
})();

let uuidv4 = function v4(
    options?:
        | string
        | {
              random?: ArrayBuffer | number[];
              rng?: () => ArrayBuffer | number[];
          },
    buf?: ArrayBuffer | number[],
    offset?: number
): any {
    let buffer = buf,
        optionsCpy = options;
    let i = (buffer && offset) || 0;

    if (typeof optionsCpy === "string") {
        buffer = optionsCpy === "binary" ? new Array(16) : undefined;
        optionsCpy = undefined;
    }
    optionsCpy = optionsCpy || {};

    let rnds = optionsCpy["random"] || (optionsCpy["rng"] || rng)();

    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    // @ts-ignore
    rnds[6] = (rnds[6] & 0x0f) | 0x40;
    // @ts-ignore
    rnds[8] = (rnds[8] & 0x3f) | 0x80;

    // Copy bytes to buffer, if provided
    if (buffer) {
        for (let ii = 0; ii < 16; ++ii) {
            // @ts-ignore
            buffer[i + ii] = rnds[ii];
        }
    }

    return buffer || bytesToUuid(rnds as number[]);
};
export default uuidv4;

